import { createSelector } from 'reselect';
import { isInArray } from '../../../core/util/is-in-array';
import { Control } from '../../../vas/business-objects/control/control.model';
import { ComplexControl } from '../../../vas/controls/complex/complex-control.model';
import { VasState } from '../../../vas/store/store-type';
import { FormManagerValidationRules } from './form-manager-validation-rules';

export class SelectorsFormManager {
    static globalState = createSelector(state => state, (state: VasState) => state);
    static state = createSelector(state => state, (state: VasState) => state.formManager);

    static account = createSelector(SelectorsFormManager.state, state => state.account);
    static user = createSelector(SelectorsFormManager.state, state => state.user);
    static membership = createSelector(SelectorsFormManager.state, state => state.membership);
    static accessGroups = createSelector(SelectorsFormManager.state, state => state.accessGroups.ids.map(id => state.accessGroups.entities[id]));

    static controlState = createSelector(SelectorsFormManager.state, state => state.control);
    static controlTypeState = createSelector(SelectorsFormManager.state, state => state.controlType);
    static formState = createSelector(SelectorsFormManager.state, state => state.form);
    static groupState = createSelector(SelectorsFormManager.state, state => state.group);

    static controls = createSelector(SelectorsFormManager.controlState, state => state.ids.map(id => state.entities[id]));
    static controlTypes = createSelector(SelectorsFormManager.controlTypeState, state => state.ids.map(id => state.entities[id]));
    static forms = createSelector(SelectorsFormManager.formState, state => state.ids.map(id => state.entities[id]));
    static groups = createSelector(SelectorsFormManager.groupState, state => state.ids.map(id => state.entities[id]));

    static selectedForm = createSelector(SelectorsFormManager.formState, state => state.entities[state.selected]);
    static selectedGroup = createSelector(SelectorsFormManager.groupState, state => state.entities[state.selected]);
    static dirty = createSelector(SelectorsFormManager.state, state => state.dirty);

    static controlFormControl = createSelector(SelectorsFormManager.state, state => state.controlForm.control);
    static subControlFormControl = createSelector(SelectorsFormManager.state, state => state.subControlForm.control);
    static subControlFormSubControl = createSelector(SelectorsFormManager.state, state => state.subControlForm.subControl);

    static selectedGroupControls = createSelector(SelectorsFormManager.controls, SelectorsFormManager.selectedGroup, (controls, group) => {

        if (!group) {
            return [];
        }

        return controls
            .filter(c => c.group === group.id)
            .sort((a, b) => a.sequence - b.sequence);
    });

    static attachedGroups = createSelector(SelectorsFormManager.groups, SelectorsFormManager.selectedForm, (groups, form) => {

        if (!form) {
            return [];
        }

        return groups
            .filter(g => isInArray(form.id, g.forms))
            .sort((a, b) => a.sequence - b.sequence);
    });

    static detachedGroups = createSelector(SelectorsFormManager.groups, SelectorsFormManager.selectedForm, (groups, form) => {

        if (!form) {
            return groups;
        }

        return groups
            .filter(g => !isInArray(form.id, g.forms))
            .sort((a, b) => a.sequence - b.sequence);
    });

    static controlFormInvalidNames = createSelector(
        SelectorsFormManager.controls,
        SelectorsFormManager.controlFormControl,
        SelectorsFormManager.attachedGroups,
        (controls, control, groups) => {

            const groupIds = groups.map(group => group.id);

            return controls
                .filter(c => isInArray(c.group, groupIds) && c.id !== control.id)
                .map(c => c.name);
        });

    static subControlFormInvalidNames = createSelector(
        SelectorsFormManager.subControlFormControl,
        SelectorsFormManager.subControlFormSubControl,
        (control: ComplexControl, subControl: Control) => {
            return (control.config.controls || [])
                .filter(c => c.id !== subControl.id)
                .map(c => c.name);
        }
    );

    static formValidationRules = createSelector(
        SelectorsFormManager.forms,
        SelectorsFormManager.groups,
        SelectorsFormManager.controls,
        (forms, groups, controls) => {
            return [
                // FormManagerValidationRules.hasJobStatus(forms, groups, controls)
            ];
        }
    );

    static visibilityControls = createSelector(
        SelectorsFormManager.globalState,
        SelectorsFormManager.selectedForm,
        SelectorsFormManager.groups,
        (state, form, groups) => {
            const groupIds = groups
                .filter(group => isInArray(form.id, group.forms))
                .map(group => group.id);
            return state.control.ids
                .map(id => state.control.entities[id])
                .filter(control => isInArray(control.group, groupIds))
                .sort((a, b) => a.title.localeCompare(b.title));
        }
    );
}



// WEBPACK FOOTER //
// ./src/app/pages/form-manager-page/form-manager-page.selectors.ts